import styled from 'styled-components';

import { theme, Tooltip } from '@notino/react-styleguide-v20';

interface StyledToolTipContentProps {
  width: number;
  textAlign?: 'left' | 'center';
}

export const StyledToolTipContent = styled.p<StyledToolTipContentProps>`
  box-sizing: content-box;
  white-space: normal;
  margin: 0 auto;
  padding: 0.5rem;
  text-align: ${({ textAlign }) => textAlign ?? 'center'};
  width: max-content;
  max-width: ${({ width }) => width}px;
`;

export const StyledInfoMarkWrapper = styled.div`
  font-size: 0.875rem;

  & svg {
    vertical-align: middle;
  }

  &:hover svg {
    transition: color 0.4s ease;
    color: ${theme.color.text.primary} !important;
  }
`;

export const StyledTooltip = styled(Tooltip)`
  bottom: 0.125rem;
`;
